module.exports = __webpack_public_path__ + "assets/img/c6499b990adf85d24467e3ace0855e45.svg";